import React from "react";
import { connect } from "react-redux";
import {  Translate, translate, I18n } from "react-i18nify";
import { Link } from 'react-router-dom';
import {
  Button,
  Col,
  Form,
  Input,
  Label,
  InputGroup,
  InputGroupText,
  FormFeedback,
  FormGroup,
  Row
} from "reactstrap";
import * as Yup from "yup";
import { Formik } from "formik";
import { authLoadAccount } from "../../config/model/auth/authActions";
import { Redirect } from "react-router-dom";

const initialValues = {
  email: "",
  password: ""
};

const validationSchema = function() {
  return Yup.object().shape({
    email: Yup.string()
      .email(`${translate("error_messages.email_invalid")}`)
      .required(`${translate("error_messages.email_required")}`),
    password: Yup.string().required(
      `${translate("error_messages.password_required")}`
    )
  });
};

const validate = getValidationSchema => {
  return values => {
    const validationSchema = getValidationSchema(values);
    try {
      validationSchema.validateSync(values, { abortEarly: false });
      return {};
    } catch (error) {
      return getErrorsFromValidationError(error);
    }
  };
};


const getErrorsFromValidationError = validationError => {
  const FIRST_ERROR = 0;
  return validationError.inner.reduce((errors, error) => {
    return {
      ...errors,
      [error.path]: error.errors[FIRST_ERROR]
    };
  }, {});
};

export const LoginForm = (props) => {
    const { login } = props;
    return !props.authToken ? (
      <Formik
        initialValues={initialValues}
        validate={validate(validationSchema)}
        onSubmit={login}        
        >
          {props => (
            <Form onSubmit={props.handleSubmit} noValidate name="loginForm">
              
              <p className="text-muted mb-4">
                <Translate value="subtitle" />
              </p>

              <FormGroup>
                <Label for="email">
                  <Translate value="user" />
                </Label>
                <InputGroup className="mb-3">
                    <InputGroupText>
                      <i className="icon-user" />
                    </InputGroupText>
                    <I18n render={() => <Input
                    type="email"
                    name="email"
                    id="email"
                    placeholder={`${translate("email")}`}
                    autoComplete="email"
                    valid={!props.errors.email && props.touched.email}
                    invalid={props.touched.email && !!props.errors.email}
                    required
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    value={props.values.email}
                    /> } />
                    <FormFeedback>{props.errors.email}</FormFeedback>
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label for="password">
                  <Translate value="password" />
                </Label>
                <InputGroup className="mb-4">
                    <InputGroupText>
                      <i className="icon-lock" />
                    </InputGroupText>
                    <I18n render={() =>  <Input
                    type="password"
                    name="password"
                    id="password"
                    placeholder={`${translate("password")}`}
                    autoComplete="new-password"
                    valid={!props.errors.password && props.touched.password}
                    invalid={props.touched.password && !!props.errors.password}
                    required
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    value={props.values.password}
                    /> } />
                    <FormFeedback>{props.errors.password}</FormFeedback>
                </InputGroup>
              </FormGroup>
              <Row>
                <Col xs="6">
                  <Button
                    type="submit"
                    color="primary"
                    className="px-4"
                    disabled={props.isSubmitting || !props.isValid}
                  >
                    {props.isSubmitting
                      ? <I18n render={() => <span>{translate("loading...")}</span>} />
                      : <I18n render={() => <span>{translate("log_in")}</span>} />
                    }
                  </Button>
                </Col>
                <Col xs="6" className="text-right">
                  <Link to="/reset-password">
                    <Button color="link" className="px-0">
                      <Translate value="forgot_password" />
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Form>
          )}
      </Formik>
    ) : (
      <Redirect to="/" />
    );
  
}

const mapStateToProps = state => ({
  authToken: !!state.auth.token
});

const mapDispatchToProps = dispatch => ({
  login: ({ email, password }, conf) =>
  dispatch(authLoadAccount({ email, password }, conf))
});

export const connectedLoginForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginForm);

export default LoginForm;
